import Breadcrumb from 'components/Common/Breadcrumb'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getByIdQuotes } from 'store/actions';
import AirShipperInformationForm from './AirShipperInformationForm';
import SeaShipperInformationForm from './SeaShipperInformationForm';

const ShipperInformation = () => {
    document.title = "Shipper Information | Glottis Logistics";

    const dispatch = useDispatch()
    const { quoteId, shipperId } = useParams()
    const { quote } = useSelector(state => ({
        quote: state.GetQuoteById.quote?.quote,
    }), shallowEqual)
    useEffect(() => {
        dispatch(getByIdQuotes(quoteId))
    }, [quoteId, shipperId])

    return (
        <div className="page-content shipper-info shipper-details">
            <div className="container-fluid accordion-style">
                {quote && quote?.shipmentBy === 'AIR' ? <AirShipperInformationForm quote={quote} shipperId={shipperId} /> : <SeaShipperInformationForm quote={quote} shipperId={shipperId} />}
            </div>
        </div>
    )
}

export default ShipperInformation